import $ from 'jquery';

function updateCharacterLimitCounter(input) {
  const $counter = $(input).closest('.form-group').find('[data-character-limit-counter]');
  if ($counter.length === 0) return;

  const message = $counter.data('message');
  const current = input.value.length;
  const maximum = Number(input.maxLength);
  const rule = input.dataset.characterRule || '';
  $counter.find('[data-character-count-display]')
    .text(message.replace(/__MAXIMUM__/g, maximum).replace('__CURRENT__', current));
  $counter.find('[data-character-rule-display]').text(rule);
  if (current < maximum) {
    $counter.removeClass('text-danger');
  }
}

function initializeTaxInterviewCharacterLimits(root) {
  $(root).find('[data-character-limit]').each(function() {
    updateCharacterLimitCounter(this);
  });
}

function updateCountryDependentCharacterLimits(country) {
  const isUs = country.toUpperCase() === 'US';
  $('[data-country-dependent-character-limit]').each(function() {
    this.maxLength = isUs ? 12 : 9;
    this.dataset.allowedCharacterPattern = isUs ? this.dataset.usAllowedCharacterPattern : this.dataset.foreignAllowedCharacterPattern;
    this.dataset.characterRule = isUs ? this.dataset.usCharacterRule : this.dataset.foreignCharacterRule;
    updateCharacterLimitCounter(this);
  });
}

function wouldExceedCharacterLimit(input, insertedText) {
  const maximum = Number(input.maxLength);
  const start = input.selectionStart === null ? input.value.length : input.selectionStart;
  const end = input.selectionEnd === null ? start : input.selectionEnd;
  const proposedLength = input.value.length - (end - start) + insertedText.length;
  return proposedLength > maximum;
}

function rejectOverLimitInput(input, event, insertedText) {
  if (!wouldExceedCharacterLimit(input, insertedText)) return;

  event.preventDefault();
  $(input).closest('.form-group').find('[data-character-limit-counter]').addClass('text-danger');
}

function rejectDisallowedCharacters(input, event, insertedText) {
  const pattern = input.dataset.allowedCharacterPattern;
  const start = input.selectionStart === null ? input.value.length : input.selectionStart;
  const end = input.selectionEnd === null ? start : input.selectionEnd;
  const proposedValue = input.value.slice(0, start) + insertedText + input.value.slice(end);
  if (!pattern || new RegExp(pattern).test(proposedValue)) return;

  event.preventDefault();
}

function rejectAdjacentSpaces(input, event, insertedText) {
  if (!input.hasAttribute('data-no-adjacent-spaces')) return;

  const start = input.selectionStart === null ? input.value.length : input.selectionStart;
  const end = input.selectionEnd === null ? start : input.selectionEnd;
  const proposedValue = input.value.slice(0, start) + insertedText + input.value.slice(end);
  if (proposedValue.includes('  ')) event.preventDefault();
}

window.initializeTaxInterviewCharacterLimits = initializeTaxInterviewCharacterLimits;

$(document).on('beforeinput', '[data-character-limit], [data-no-adjacent-spaces]', function(event) {
  const nativeEvent = event.originalEvent;
  if (nativeEvent && nativeEvent.inputType && nativeEvent.inputType.indexOf('insert') === 0 && typeof nativeEvent.data === 'string') {
    if (this.hasAttribute('data-character-limit')) {
      rejectOverLimitInput(this, event, nativeEvent.data);
      if (!event.isDefaultPrevented()) rejectDisallowedCharacters(this, event, nativeEvent.data);
    }
    if (!event.isDefaultPrevented()) rejectAdjacentSpaces(this, event, nativeEvent.data);
  }
});

$(document).on('paste', '[data-character-limit], [data-no-adjacent-spaces]', function(event) {
  const clipboard = event.originalEvent && event.originalEvent.clipboardData;
  if (clipboard) {
    const insertedText = clipboard.getData('text');
    if (this.hasAttribute('data-character-limit')) {
      rejectOverLimitInput(this, event, insertedText);
      if (!event.isDefaultPrevented()) rejectDisallowedCharacters(this, event, insertedText);
    }
    if (!event.isDefaultPrevented()) rejectAdjacentSpaces(this, event, insertedText);
  }
});

$(document).on('drop', '[data-character-limit], [data-no-adjacent-spaces]', function(event) {
  const transfer = event.originalEvent && event.originalEvent.dataTransfer;
  if (transfer) {
    const insertedText = transfer.getData('text');
    if (this.hasAttribute('data-character-limit')) {
      rejectOverLimitInput(this, event, insertedText);
      if (!event.isDefaultPrevented()) rejectDisallowedCharacters(this, event, insertedText);
    }
    if (!event.isDefaultPrevented()) rejectAdjacentSpaces(this, event, insertedText);
  }
});

$(document).on('input', '[data-character-limit]', function() {
  updateCharacterLimitCounter(this);
});

$(document).on('change', '.select-country', function() {
  updateCountryDependentCharacterLimits(this.value || '');
});

$(function() {
  if ($('#js-tax-interview').length) {
    initializeTaxInterviewCharacterLimits(document);

    window.onpopstate = function(event){
      const index = event != null ? (event.state ? event.state.stepIndex : 0) : 0;

      const $progressBarSteps = $('#js-tax-interview-progress-bar li');
      $progressBarSteps.removeClass('current');
      const $previousProgressBarSteps = $progressBarSteps.slice(0, index + 1);
      $previousProgressBarSteps.addClass('current');

      const $taxInterviewSteps = $('#js-tax-interview-steps li.js-tax-interview-step');
      $taxInterviewSteps.hide();

      const $previousStep = $taxInterviewSteps.eq(index);
      $previousStep.show();
    };

    $('#js-tax-interview-steps').on('click', '.js-tax-interview-pager-previous', function(event){
      history.back();
      return event.preventDefault();
    });

    $(window).on('beforeunload', () => 'All progress will be lost!');

    $(document).on('change', '.js-tax-interview-step .has-error input, .js-tax-interview-step .has-error select',function(){
      const currentStep = getCurrentStep();
      const form = $(`#${currentStep} form`);
      const formData = form.serializeArray();
      const fieldName = $(this).attr('name');
      const containerDom = $(this).parents('.has-error');
      formData.push({ name: `tax_interview_step_${getCurrentStep(true)}_form[is_validation]`, value: 1 })
      $.ajax({
        type: 'POST',
        dataType : 'json',
        url: form.attr('action'),
        data: $.param(formData),
        success: function (result) {
          if (fieldName && containerDom.length > 0 && (!result || !result.errors[fieldName.replace(/.*\[|\]/g, '')])) {
            $(containerDom[0]).removeClass('has-error');
          } else if (containerDom.length > 0 && result && result.errors[fieldName.replace(/.*\[|\]/g, '')]) {
            $(containerDom[0]).find('.help-block').html(result.errors[fieldName.replace(/.*\[|\]/g, '')][0]);
          }
        }
      });
    });
  }
});

function getCurrentStep(onlyStep = false) {
  let currentStep = 'js-tax-interview-step-one';
  $('.js-tax-interview-step').each(function () {
    if ($(this).css('display') !== 'none' && $(this).html().length > 0) {
      currentStep = $(this).attr('id');
      if (onlyStep && currentStep) {
        currentStep = currentStep.replace('js-tax-interview-step-', '')
      }
    }
  })
  return currentStep;
}

class Step {
  constructor() {
    this.toggle = this.toggle.bind(this);
    this.setRequired = this.setRequired.bind(this);
    this.init();
  }

  init(){
    //empty function;
  }
  toggle($formGroup, show){
    $formGroup.toggleClass('hidden', !show).toggle(show);
    this.setRequired($formGroup, show);
  }

  setRequired($formGroup, required){
    const $optional = $formGroup.find('label span.text-muted');
    const $input = $formGroup.find('input, select');

    $optional.toggle(!required);
    $input.attr('required', required ? 'required' : null);
  }
}

//window.Step = Step

class StepTwo extends Step {
  static onload() {
    $('.select2-select').select2({
      allowClear: true,
      placeholder: 'Select an option'
    });

    return new StepTwo();
  }
  init() {
    this.entityTypeChangeHandler = this.entityTypeChangeHandler.bind(this);
    this.showDateOfBirth = this.showDateOfBirth.bind(this);
    this.showDateOfBirthgowCompanyName = this.showDateOfBirthgowCompanyName.bind(this);
    this.showLimitedLiabilityCompany = this.showLimitedLiabilityCompany.bind(this);
    this.isUSEntity = this.isUSEntity.bind(this);
    this.isIndividual = this.isIndividual.bind(this);
    this.showCompanyName = this.showCompanyName.bind(this);
    this.showStates = this.showStates.bind(this);
    this.$stepTwoContainter = $('#js-tax-interview-step-two');
    this.$entityType = this.$stepTwoContainter.find('select[name="tax_interview_step_two_form[entity_type]"]');
    this.$isUSEntity = this.$stepTwoContainter.find('input[name="tax_interview_step_two_form[is_us_entity]"]');
    this.$dateOfBirthFormGroup = this.$stepTwoContainter.find('div.form-group.tax_interview_step_two_form_date_of_birth');
    this.$companyNameFormGroup = this.$stepTwoContainter.find('div.form-group.tax_interview_step_two_form_company_name');
    this.$limitedLiabilityCompanyFormGroup = this.$stepTwoContainter.find('div.form-group.tax_interview_step_two_form_limited_liability_company');
    this.$entityType.change(this.entityTypeChangeHandler);
    this.$showStateOnLoad = this.showStates();
    this.$onChangeCountry = $('.select-country').on('select2:select', (e) => {
      return this.showStates(e.params.data.id)
    });
  }
  showStates(country) {
    const form = $("#new_tax_interview_step_two_form");
    const stateFieldSlot = $("#tax-interview-state-fields");
    const inputState = $("#optional-state").closest('.form-group');
    const selectStateUs = $("#required-state-us").parent();
    const selectStateCa = $("#required-state-ca").parent();
    const elements = [inputState, selectStateUs, selectStateCa];

    //remove items from form
    elements.map(el => form.after(el.hide()));

    const selectedCountry = country ? country : $('.select-country').select2('data')[0].id;
    if(selectedCountry === "US") {
      //add select to the state field column
      stateFieldSlot.append(selectStateUs.show());
      return false;
    } else if (selectedCountry === "CA") {
      stateFieldSlot.append(selectStateCa.show());
      return false;
    }

    //add input to the state field column
    stateFieldSlot.append(inputState.show());

  }
  entityTypeChangeHandler(event){
    const newEntityType = $(event.target).val();
    if(newEntityType==='individual'){
      $("#tax_interview_step_two_form_limited_liability_company_false").prop("checked", true);
    }

    const nameInput = this.$stepTwoContainter.find('input[name="tax_interview_step_two_form[full_name]"]')[0];
    const nameType = newEntityType === 'individual' ? 'individual' : 'business';
    nameInput.dataset.allowedCharacterPattern = nameInput.dataset[`${nameType}NamePattern`];
    nameInput.dataset.characterRule = nameInput.dataset[`${nameType}NameRule`];
    updateCharacterLimitCounter(nameInput);

    this.toggle(this.$dateOfBirthFormGroup, this.showDateOfBirth(newEntityType));
    this.toggle(this.$companyNameFormGroup, this.showCompanyName(newEntityType));
    this.toggle(this.$limitedLiabilityCompanyFormGroup, this.showLimitedLiabilityCompany(newEntityType));
  }

  showDateOfBirth(entityType){
    return (entityType.length === 0) || (!this.isUSEntity() && this.isIndividual(entityType));
  }

  showDateOfBirthgowCompanyName(entityType){
    return (entityType.length === 0) || !this.isIndividual(entityType);
  }

  showLimitedLiabilityCompany(entityType){
    return (entityType.length === 0) || !this.isIndividual(entityType);
  }

  isUSEntity() {
    return this.$isUSEntity.val() === 'true';
  }

  isIndividual(entityType){
    if (entityType == null) { 
      entityType = this.$entityType.val(); 
      $("#tax_interview_step_two_form_limited_liability_company_false").prop("checked", true);
    }
    return entityType === 'individual';
  }

  showCompanyName(entityType){
    return (entityType.length === 0) || !this.isIndividual(entityType);
  }
}

class StepFive extends Step {
  static onload() {
    return new StepFive;
  }

  static onerror() {
    $('#js-tax-submit-error-modal').modal('show');
  }
  consentToElectronicSignatureChangeHandler(event){
    const consentToElectronicSignature = $(event.target).val() === 'true';
    this.$signElectonically.toggle(consentToElectronicSignature);
    this.toggle(this.$signElectonicallyFormGroups, consentToElectronicSignature);
  }
  init(){
    this.consentToElectronicSignatureChangeHandler = this.consentToElectronicSignatureChangeHandler.bind(this);
    this.$signElectonically = $('#js-sign-electronically');
    this.$stepFiveContainter = $('#js-tax-interview-step-five');
    this.$consentToElectronicSignature = this.$stepFiveContainter.find('input[name="tax_interview_step_five_form[electronic_signature_consent]"]');
    this.$signElectonicallyFormGroups = this.$signElectonically.find('div.form-group');
    this.$consentToElectronicSignature.change(this.consentToElectronicSignatureChangeHandler);
  }
}

window.StepOne = null;
window.StepTwo = StepTwo;
window.StepThree = null;
window.StepFour = null;
window.StepFive = StepFive;
